import RootState from 'store/state';
import { useSelector } from 'react-redux';

export default function useNotification(): RootState["notification"] {

    const notification = useSelector<RootState, RootState["notification"]>(
        ({ notification }) => notification
    )

    return notification
}
